module.exports = __webpack_public_path__ + "static/img/more.7b862cc7.svg";